import Helium from '../helium.min.js';

const app = new Helium();

// Channels globales
export const sessionChannel = app.factory('session', {
    user: null,
    token: null,
    isAuthenticated: false
});

export const contextChannel = app.factory('context', {
    branchId: null,
    lang: 'es'
});

// Canal de Notificaciones: { type: 'success' | 'error' | 'info', message: string, id: number }
export const notificationChannel = app.factory('notifications', null);

export const uiChannel = app.factory('ui', {
    isSidebarOpen: false,
    isContextDrawerOpen: false,
    isLoading: false,
    loaderMessage: ''
});

/**
 * Helpers para el Loader Global
 */
export const showLoader = (message = 'Cargando...') => {
    uiChannel.send(state => ({ ...state, isLoading: true, loaderMessage: message }));
};

export const hideLoader = () => {
    uiChannel.send(state => ({ ...state, isLoading: false, loaderMessage: '' }));
};

export const productFormChannel = app.factory('productForm', {
    modifierType: 'simple'
});

/**
 * Helper para enviar notificaciones fácilmente
 */
export const notify = (message, type = 'info') => {
    notificationChannel.send({
        id: Date.now(),
        message,
        type
    });
};

/**
 * Verifica si el usuario cuenta con un feature específico en su suscripción
 */
export const hasFeature = (featureName) => {
    const session = sessionChannel.value;
    return session?.subscription?.features?.[featureName] === true;
};

/**
 * Verifica si el usuario tiene suficientes créditos de IA para una acción
 */
export const hasIACredits = (iaActionName) => {
    const session = sessionChannel.value;
    const remaining = session?.subscription?.ia?.remaining || 0;
    const cost = session?.subscription?.ia?.costs?.[iaActionName] || 1;
    return remaining >= cost;
};

/**
 * Verifica si el usuario aún tiene disponible capacidad de un límite específico
 */
export const hasLimitAvailable = (limitName) => {
    const session = sessionChannel.value;
    const limit = session?.subscription?.limits?.[limitName];
    const usage = session?.subscription?.usage?.[limitName] || 0;
    
    // Si no existe el límite definido o es ilimitado (-1)
    if (limit === undefined || limit === -1) return true;
    
    return limit > usage;
};

/**
 * Mapa de idiomas soportados con sus nombres y banderas
 */
export const SUPPORTED_LANGUAGES = {
    es: { name: 'Español', flag: '🇲🇽' },
    en: { name: 'English', flag: '🇺🇸' },
    it: { name: 'Italiano', flag: '🇮🇹' },
    fr: { name: 'Français', flag: '🇫🇷' },
    de: { name: 'Deutsch', flag: '🇩🇪' },
    ru: { name: 'Русский', flag: '🇷🇺' },
    pt: { name: 'Português', flag: '🇧🇷' }
};

/**
 * Cambia el idioma de contenido global y lo persiste en localStorage
 */
export const setLanguage = (lang) => {
    if (!SUPPORTED_LANGUAGES[lang]) {
        console.warn(`Idioma no soportado: ${lang}`);
        return;
    }
    contextChannel.send(state => ({ ...state, lang }));
    localStorage.setItem('_lang', lang);
};

/**
 * Obtiene el nombre legible del idioma actual o especificado
 */
export const getLanguageName = (lang = null) => {
    const targetLang = lang || contextChannel.value?.lang || 'es';
    return SUPPORTED_LANGUAGES[targetLang]?.name || 'Español';
};

/**
 * Inicializa el idioma desde localStorage al cargar la app
 * Llama esto en el app-root o punto de entrada
 */
export const initLanguage = () => {
    const savedLang = localStorage.getItem('_lang');
    if (savedLang && SUPPORTED_LANGUAGES[savedLang]) {
        contextChannel.send(state => ({ ...state, lang: savedLang }));
    }
};